import { render } from "./DashboardLayout.vue?vue&type=template&id=f3ce413a"
import script from "./DashboardLayout.vue?vue&type=script&lang=js"
export * from "./DashboardLayout.vue?vue&type=script&lang=js"

import "./DashboardLayout.vue?vue&type=style&index=0&id=f3ce413a&lang=scss"

import exportComponent from "/Users/garay/code/omnichannel/dashboard-agente/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__